import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './styles.css';

class Dropdown extends React.Component {

  static propTypes = {
    onSelect: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    defaultText: PropTypes.string,
    noResultsText: PropTypes.string,
    clearValueText: PropTypes.string,
    options: PropTypes.array,
    selected: PropTypes.string,
    px: PropTypes.number,
    py: PropTypes.number,
    searchable: PropTypes.bool,
    clearable: PropTypes.bool,
    verticalAlign: PropTypes.bool,
    readonly: PropTypes.bool,
    setRequiredField: PropTypes.func,
    unsetRequiredField: PropTypes.func,
    guestId: PropTypes.string,
    changeAll: PropTypes.bool,
    nonRequired: PropTypes.bool,
  }
  static defaultProps = {
    onSelect: () => {},
    options: [],
    px: 3,
    py: 2,
    searchable: false,
    clearable: false,
  }

  onFocus = () => {
    this.props.onFocus();
  }

  onBlur = (selected, changeAll) => {
    const { setRequiredField, unsetRequiredField, onBlur, nonRequired } = this.props;
    if (selected && !changeAll && !nonRequired) {
      unsetRequiredField();
    } else if (!selected && !changeAll && !nonRequired) {
      setRequiredField();
    }
    onBlur();
  }

  render() {
    const { options, selected, onSelect, defaultText, noResultsText, clearValueText, searchable, clearable, verticalAlign, readonly, changeAll } = this.props;
    return (
      <Select
        className={verticalAlign ? 'vertical-align' : ''}
        onBlurResetsInput={false}
        onSelectResetsInput={false}
        valueKey={'code'}
        labelKey={'text'}
        matchPos={'start'}
        options={options}
        simpleValue
        placeholder={defaultText}
        noResultsText={noResultsText}
        clearable={clearable}
        clearValueText={clearValueText}
        disabled={readonly}
        value={selected}
        onChange={onSelect}
        searchable={searchable}
        onBlur={() => this.onBlur(selected, changeAll)}
        onFocus={this.onFocus}
      />
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/organisms/Dropdown/index.js